export const UPDATE_EXPORT_COUNTER = 'REPORTING_UPDATE_EXPORT_COUNTER';

export const updateExportCounter = exportCounter => ({
  type: UPDATE_EXPORT_COUNTER,
  exportCounter,
});
